import React, { ReactNode, useState } from 'react';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { updateQuizTranslations } from 'store/quiz/quizSlice';
import { selectQuiz } from 'store/quiz/quizSelectors';
// MUI
import { MenuItem, TextField, Tooltip } from '@mui/material';
// i18next
import { useTranslation } from 'react-i18next';
import QuizTypes from 'types/QuizTypes';

export const countries = [
  { label: 'English', value: 'en', imgUrl: '/images/flags/us.png' },
  { label: 'Español', value: 'es', imgUrl: '/images/flags/es.png' },
  { label: 'Svenska', value: 'se', imgUrl: '/images/flags/se.png' },
  { label: 'Português', value: 'pt', imgUrl: '/images/flags/pt.png' },
  { label: 'العربية', value: 'ar', imgUrl: '/images/flags/ar.png' },
  { label: 'हिन्दी', value: 'hi', imgUrl: '/images/flags/hi.png' },
]

const LanguageSelect:React.FC = () => {
  const dispatch = useAppDispatch();

  const quiz = useAppSelector(selectQuiz);

  const nextCountries = countries.filter(country => quiz.additionalLanguages?.includes(country.value) || quiz.language === country.value);

  const { i18n } = useTranslation('common');

  const [lang, setLang] = useState(localStorage.getItem('i18nextLng') || 'en');

  const handleLanguage = (event:any) => {
    const { value:lang } = event.target;
    setLang(lang);
    i18n.changeLanguage(lang);
    dispatch(updateQuizTranslations(lang));
  }

  const isPollQuiz = quiz?.type === QuizTypes.Poll;

  if (nextCountries.length <= 1) return null;
  return (
      <TextField
        variant="outlined"
        size="small"
        select
        onChange={handleLanguage}
        value={lang}
        sx={{ my: 2 }}
        SelectProps={{
          renderValue: (value: any):ReactNode => {
            const country = countries.find(country => country.value === value);
            return (
              <Tooltip title="Choose your language">
                <span className="flex items-center font-bold text-sm">
                  <img src={country?.imgUrl} width="24" height="24" style={{ objectFit: 'cover' }} alt={lang} />&nbsp;&nbsp;{country?.label}
                </span>
              </Tooltip>
            )
          }
        }}
        InputProps={{
          style: {
            color: isPollQuiz ? 'white' : 'initial',
          }
        }}
      >
        {nextCountries.map(country => (
          <MenuItem key={country.value} value={country.value}>
            <img src={country.imgUrl} alt={country.label} width="32" height="32" style={{ objectFit: 'cover' }} />&nbsp;&nbsp;{country.label}
          </MenuItem>
        ))}
      </TextField>
  );
}

export default LanguageSelect;
